import React from 'react';
import { Typography, notification, Skeleton, message } from 'antd';
import { Card, Form, Input, DatePicker, Button, Spin } from 'antd';
import { observer } from "mobx-react";
import moment from 'moment';

import { ShippingItemStoreContext } from './AppContexts';

import { PHONE_NO_WITH_PREFIX_RE } from './common';

const ShippingItemDetailForm = Form.create({
	name: 'shipping-item-detail',
	onFieldsChange(props, changedFields) {
		//console.log('meh');
		props.onChange(changedFields);
	},
	mapPropsToFields(props) {
		//console.log(props);
		return {
			deliveryNoteId: Form.createFormField({
				...props.deliveryNoteId,
				value: props.deliveryNoteId.value,
			}),
			deliveryNoteDate: Form.createFormField({
				...props.deliveryNoteDate,
				value: props.deliveryNoteDate.value ? moment(props.deliveryNoteDate.value) : null,
			}),
			client: Form.createFormField({
				...props.client,
				value: props.client.value,
			}),
			recipient: Form.createFormField({
				...props.recipient,
				value: props.recipient.value,
			}),
			attention: Form.createFormField({
				...props.attention,
				value: props.attention.value,
			}),
			address: Form.createFormField({
				...props.address,
				value: props.address.value,
			}),
			zip: Form.createFormField({
				...props.zip,
				value: props.zip.value,
			}),
			city: Form.createFormField({
				...props.city,
				value: props.city.value,
			}),
			provinceIT: Form.createFormField({
				...props.provinceIT,
				value: props.provinceIT.value,
			}),
			country: Form.createFormField({
				...props.country,
				value: props.country.value,
			}),
			phone: Form.createFormField({
				...props.phone,
				value: props.phone.value,
			}),
			grossWeight: Form.createFormField({
				...props.grossWeight,
				value: props.grossWeight.value,
			}),
			description: Form.createFormField({
				...props.description,
				value: props.description.value,
			}),
			packageSeq: Form.createFormField({
				...props.packageSeq,
				value: props.packageSeq.value,
			}),
			packagesTot: Form.createFormField({
				...props.packagesTot,
				value: props.packagesTot.value,
			}),
			notes: Form.createFormField({
				...props.notes,
				value: props.notes.value,
			}),
		};
	},
	/*onValuesChange(_, values) {
		console.log(values);
	},*/
})(
    (props) => {  // function component
	const formItemLayout = {
		labelCol: {
			xs: { span: 24 },
			sm: { span: 8 },
		},
		wrapperCol: {
			xs: { span: 24 },
			sm: { span: 16 },
		},
	};
	const { getFieldDecorator } = props.form;

	let handleSubmit = (e) => {
		//console.log('internal handle submit');
		e.preventDefault();
		props.form.validateFieldsAndScroll((err, values) => {
			if (!err) {
				props.onSubmit(values);
			}
		});
	};

	let getNumericValueFromEvent = (e) => {
		if (e.currentTarget.value.length == 0){
			return null; //we want to return null if empty ("")
		}
		return e.currentTarget.value;
		/* doesn't support things such as 5.05
		if (e.currentTarget.value.indexOf('.') !== -1 && /[.]\s*$/.test(e.currentTarget.value) ){
			return e.currentTarget.value;
		}
		let val = Number(e.currentTarget.value)
		if (!isNaN(val)){
			return val;
		}
		return e.currentTarget.value;*/
	}

	let getDateValueFromDatePicker = (momentObj) => {
		if (momentObj){
			return momentObj.toDate();
		}
		return momentObj;
	}

	return (
		<Form className='shipping-item-edit' {...formItemLayout} onSubmit={handleSubmit}>
			<Form.Item label="Modifica campi generati dal sistema">
				<Input type="checkbox" onChange={props.changeSysFieldsDisable} /> 
			</Form.Item>
			<Form.Item label='N° Bolla'>
			{ getFieldDecorator('deliveryNoteId', {
				rules: [ { type: 'number', message: 'Il n° di Bolla deve essere un numero'
					,transform: (value) => (value ? Number(value) : value)  }
				]
				,getValueFromEvent: getNumericValueFromEvent
			})( <Input type="text" placeholder="delivery note ID" disabled={props.sysGeneratedFieldsDisabled} />) }
			</Form.Item>
			<Form.Item label='Data della Bolla'>
			{ getFieldDecorator('deliveryNoteDate', {
				rules: [ { type: 'date', message: 'La data della Bolla deve essere una data valida'
				,transform: (value) => { return (value && value.toDate) ? value.toDate() : value}  }
				]
				,getValueFromEvent: getDateValueFromDatePicker
			})( <DatePicker disabled={props.sysGeneratedFieldsDisabled} />) }
			</Form.Item>
			<Form.Item label='Cliente'>
			{ getFieldDecorator('client', {
				rules: [ { required: true, message: 'Inserisci il nome del Cliente' }
				]
			})( <Input type="text" placeholder="Client" />) }
			</Form.Item>
			<Form.Item label='Destinatario'>
			{ getFieldDecorator('recipient', { 
				rules: [ { required: true, message: 'Inserisci il nome del destinatario' }
				]
			})( <Input.TextArea rows={3} placeholder="Recipient" />) }
			</Form.Item>
			<Form.Item label='Attenzione di'>
			{ getFieldDecorator('attention', {
				rules: [ { required: true, message: 'Compila il campo "Attenzione di"' }
				]
			})( <Input type="text" placeholder="all'attenzione di" />) }
			</Form.Item>
			<Form.Item label='Indirizzo'>
			{ getFieldDecorator('address', {
				rules: [ { required: true, message: 'Inserisci un indirizzo col numero civico' }
				]
			})( <Input type="text" placeholder="via dei Platani, 20" />) }
			</Form.Item>
			<Form.Item label='CAP'>
			{ getFieldDecorator('zip', {
				rules: [ { required: true, message: 'Inserisci il Codice Postale' }
				]
			})( <Input type="text" placeholder="12345" />) }
			</Form.Item>
			<Form.Item label='Città'>
			{ getFieldDecorator('city', {
				rules: [ { required: true, message: 'Inserisci la Città' }
				]
			})( <Input type="text" placeholder="City" />) }
			</Form.Item>
			<Form.Item label='Provincia (solo Italia)'>
			{ getFieldDecorator('provinceIT', {
			})( <Input type="text" placeholder="provincia" />) }
			</Form.Item>
			<Form.Item label='Nazione'>
			{ getFieldDecorator('country', {
				rules: [ { required: true, message: 'Inserisci la Nazione' }
				]
			})( <Input type="text" placeholder="country" />) }
			</Form.Item>
			<Form.Item label='Telefono'>
			{ getFieldDecorator('phone', {
				rules: [ { pattern: PHONE_NO_WITH_PREFIX_RE
					 	,message: 'Il formato del numero di telefono è: +XX-YYYYYYYYYY, ad esempio: +39-02 8940 2627' }
				]
			})( <Input type="text" placeholder="+39-0000000000" />) }
			</Form.Item>
			<Form.Item label='Peso (in kg)'>
			{ getFieldDecorator('grossWeight', {
				rules: [ { required: true, message: 'Inserisci il peso' }
					,{ type: 'number', message: 'Il peso deve essere solo un numero'
						,transform: (value) => (value ? Number(value) : value)  }
				]
				,getValueFromEvent: getNumericValueFromEvent
			})( <Input type="text" placeholder="Peso" />) }
			</Form.Item>
			<Form.Item label='Descrizione'>
			{ getFieldDecorator('description', {
				rules: [ { required: true, message: 'Inserisci la descrizione' }
				]
			})( <Input.TextArea rows={3} placeholder="description" />) }
			</Form.Item>
			<Form.Item label='N° Collo'>
			{ getFieldDecorator('packageSeq', {
				rules: [ { type: 'number', message: 'Il collo deve essere un numero'
						,transform: (value) => (value ? Number(value) : value)  }
				]
				,getValueFromEvent: getNumericValueFromEvent
			})( <Input type="text" placeholder="package number" disabled={props.sysGeneratedFieldsDisabled} />) }
			</Form.Item>
			<Form.Item label='Totale Colli'>
			{ getFieldDecorator('packagesTot', {
				rules: [ { type: 'number', message: 'Il Totale Colli deve essere un numero'
						,transform: (value) => (value ? Number(value) : value)  }
				]
				,getValueFromEvent: getNumericValueFromEvent
			})( <Input type="text" placeholder="Totale Colli" disabled={props.sysGeneratedFieldsDisabled} />) }
			</Form.Item>
			<Form.Item label='Note di consegna'>
			{ getFieldDecorator('notes', {
				rules: [ { required: false, message: 'Inserisci le note di consegna' }
				]
			})( <Input.TextArea rows={3} placeholder="Note" />) }
			</Form.Item>

			

			<Form.Item>
				<Button type="primary" htmlType="submit">Salva</Button>
			</Form.Item>
			{ props.saving && <Spin size="small" tip="Sto salvando..." /> }
		</Form>
	);
});

@observer
class ShippingItemDetail extends React.Component {
	static contextType = ShippingItemStoreContext;

	state = {
		loading: true
		,saving: false
		,fields: {
			deliveryNoteId: { value: null }
			,deliveryNoteDate: { value: null }
			,client: { value: '' }
			,recipient: { value: '' }
			,attention: { value: '' }
			,address: { value: '' }
			,zip: { value: '' }
			,city: { value: '' }
			,provinceIT: { value: '' }
			,country: { value: '' }
			,phone: { value: '' }
			,grossWeight: { value: null }
			,description: { value: '' }
			,packageSeq: { value: null }
			,packagesTot: { value: null }
			,notes: { value: '' }
		}
		,id: this.props.match.params.id || null
		,sysGeneratedFieldsDisabled: true
	}

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		if (!this.state.id){
			this.setState({ loading: false });
			return;
		}
		this.context.fetchById(this.state.id).then( item => {
			console.log(item);
			let out = {};
			Object.keys(item).forEach( key => {
				out[key] = { value: item[key] };
			});
			this.setState( ({ fields }) => ({
				fields: { ...fields, ...out }
				,id: item.id
				,loading: false
			}));
		});
	}

	changeSysFieldsDisable = (e) => {
		this.setState({ sysGeneratedFieldsDisabled: !e.target.checked });
	}

	handleFormChange = (changedFields) => {
		console.log('handle form change', changedFields);
		this.setState(({ fields }) => ({
			fields: { ...fields, ...changedFields },
		}));
	}

	handleSubmit = (values) => {
		console.log('Received values of form: ', values);
		console.log(this.state);
		let promise = Promise.resolve();
		let submitValues = { ...values };
		if (this.state.sysGeneratedFieldsDisabled){
			delete submitValues.deliveryNoteId;
			delete submitValues.deliveryNoteDate;
			delete submitValues.packageSeq;
			delete submitValues.packagesTot;
		}
		if (!this.state.id){ //we want these two fields to null for new objects
			submitValues.deliveryNoteId = null;
			submitValues.deliveryNoteDate = null;
		}
		promise.then( () => {
			console.log('saving...');
			this.setState({ saving: true });
			if (this.state.id){
				return this.context.update({
					...submitValues
					,id: this.state.id
				}).then( () => {
					this.setState({ saving: false });
				});
			} else {
				return this.context.insert({
					...submitValues
				}).then( (item) => {
					this.setState({ saving: false, id: item.id });
				});
			}
		}).then( () => {
			notification.success({
				message: 'Operazione riuscita',
				description: 'Elemento salvato con successo',
				duration: 4
			});
		}).catch( (err) => {
			this.setState({ saving: false });
			notification.error({
				message: 'Errore',
				description: `Non posso salvare il collo. Riprova.\n${err && err.message || ''}`,
				duration: 8
			});
		});
	}

	render() {
		const fields = this.state.fields;

		return (
		<>
			<Typography.Title level={3}>{ this.state.id ? 'Dettaglio Collo' : 'Nuovo Collo' } { this.state.loading ? <Spin size="default" /> : null }</Typography.Title>
			<Card>
				<Skeleton active loading={this.state.loading} paragraph={{ rows: 4 }}>
					<ShippingItemDetailForm
						{...fields}
						changeSysFieldsDisable={this.changeSysFieldsDisable}
						sysGeneratedFieldsDisabled={this.state.sysGeneratedFieldsDisabled}
						objectId={this.state.id} saving={this.state.saving}
						onChange={this.handleFormChange} onSubmit={this.handleSubmit}
					/>
				</Skeleton>
			</Card>
		</> );
	}
}

export { ShippingItemDetail };
